import { BaseIssuanceRetailerProductExclusion } from 'codegen';
import { TRequestCallback } from 'types';

export const handleDeleteProductExclusion = (
  onDeleteTableData: TRequestCallback,
  retailerId?: string,
) => (
  id: number,
) => {
  onDeleteTableData({ callbackURL: `/retailers/${retailerId}/product-exclusions/${id}` });
};

export const handlePostProductExclusion = (
  onPostTableData: TRequestCallback<BaseIssuanceRetailerProductExclusion>,
  retailerId?: string,
) => (
  data: BaseIssuanceRetailerProductExclusion,
) => {
  // @ts-expect-error product.name - bcoz initial field dataIndex: 'product.name', in /helpers.tsx
  onPostTableData({ callbackURL: `/retailers/${retailerId}/product-exclusions/${data['product.name']}` });
};
